<ng-template kwRenderSection [section]="section" [title]="title" [rendererComponent]="rendererComponent" [marginBottom]="marginBottom"></ng-template>

